// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"165":"6b3e9363","401":"fcba2328","454":"1724f63c","469":"120649ce","876":"065a1fe6"}[chunkId] + ".css";
};